import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './archive-series.css'

const ArchiveSeries = (props) => {
  return (
    <div className="archive-series-container1">
      <Helmet>
        <title>Archive-Series - Ketame</title>
        <meta property="og:title" content="Archive-Series - Ketame" />
        <link
          rel="canonical"
          href="https://ketame.me/archive-series"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="archive-hero">
        <div className="archive-hero-wrapper">
          <div className="archive-hero-content">
            <h1 className="hero-title">
              The Ketame Vault: Where Logic Goes to Nap
            </h1>
            <p className="hero-subtitle">
              Dig through thousands of horse-centric hallucinations, memes, and
              Mike&apos;s questionable life choices.
            </p>
            <div className="archive-hero-search-container">
              <form
                action="/search"
                method="GET"
                data-form-id="4723a0cc-1de8-410e-beac-9d65ffb62822"
                className="archive-hero-form"
              >
                <div className="archive-hero-input-wrapper">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="search-icon"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="m21 21l-4.34-4.34"></path>
                      <circle cx="11" cy="11" r="8"></circle>
                    </g>
                  </svg>
                  <input
                    type="text"
                    placeholder="Search for 'Mike', 'Chaos', or 'Why?'"
                    required="true"
                    id="thq_textinput_3tKk"
                    name="textinput"
                    data-form-field-id="thq_textinput_3tKk"
                    className="archive-hero-input"
                  />
                </div>
                <button
                  type="submit"
                  id="thq_button_iMKA"
                  name="button"
                  data-form-field-id="thq_button_iMKA"
                  className="btn btn-primary"
                >
                  Find the Weird
                </button>
              </form>
            </div>
            <div className="archive-hero-quick-filters">
              <span className="section-content">Quick Jumps:</span>
              <div className="archive-hero-pills">
                <a href="#series">
                  <div className="archive-hero-pill">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"></path>
                    </svg>
                    <span>
                      {' '}
                      Series
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </div>
                </a>
                <a href="#memes">
                  <div className="archive-hero-pill">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"></path>
                    </svg>
                    <span>
                      {' '}
                      Memes
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </div>
                </a>
                <a href="#episodes">
                  <div className="archive-hero-pill">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="M12 6v6l4 2"></path>
                        <circle cx="12" cy="12" r="10"></circle>
                      </g>
                    </svg>
                    <span>
                      {' '}
                      Episodes
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="series" className="series-folders">
        <div className="series-folders-wrapper">
          <div className="series-folders-header">
            <h2 className="section-title">
              Deep Dives &amp; Multi-Panel Mayhem
            </h2>
            <div className="series-folders-controls">
              <button className="btn btn-outline btn-sm">Newest First</button>
              <button className="btn btn-outline btn-sm">A-Z</button>
            </div>
          </div>
          <div className="series-folders-grid">
            <div className="series-folder-card">
              <div className="series-folder-visual">
                <img
                  src="https://images.pexels.com/photos/6664553/pexels-photo-6664553.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Mike the Blue Horse"
                  loading="lazy"
                />
                <span className="series-badge badge-ongoing">Ongoing</span>
              </div>
              <div className="series-folder-info">
                <h3 className="section-subtitle">Mike the Blue Horse</h3>
                <p className="section-content">
                  The flagship series following Mike&apos;s struggle with
                  gravity, physics, and basic social cues.
                </p>
                <div className="series-folder-meta">
                  <span className="section-content">142 Episodes</span>
                  <a href="#">
                    <div className="btn btn-sm btn-link">
                      <span>Open Folder</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div className="series-folder-card">
              <div className="series-folder-visual">
                <img
                  src="https://images.pexels.com/photos/16516/pexels-photo.jpg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Existential Stable"
                  loading="lazy"
                />
                <span className="series-badge badge-complete">Complete</span>
              </div>
              <div className="series-folder-info">
                <h3 className="section-subtitle">Existential Stable</h3>
                <p className="section-content">
                  Short comics about the deep thoughts horses have while staring
                  at walls for three hours.
                </p>
                <div className="series-folder-meta">
                  <span className="section-content">45 Episodes</span>
                  <a href="#">
                    <div className="btn btn-sm btn-link">
                      <span>Open Folder</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div className="series-folder-card">
              <div className="series-folder-visual">
                <img
                  src="https://images.pexels.com/photos/14283336/pexels-photo-14283336.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Ketameme Classics"
                  loading="lazy"
                />
                <span className="series-badge badge-ongoing">Ongoing</span>
              </div>
              <div className="series-folder-info">
                <h3 className="section-subtitle">Ketameme Classics</h3>
                <p className="section-content">
                  The original high-energy, low-logic panels that started it
                  all. Proceed with caution.
                </p>
                <div className="series-folder-meta">
                  <span className="section-content">500+ Panels</span>
                  <a href="#">
                    <div className="btn btn-sm btn-link">
                      <span>Open Folder</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div className="series-folder-card">
              <div className="series-folder-visual">
                <img
                  src="https://images.pexels.com/photos/10064767/pexels-photo-10064767.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Barnyard Noir"
                  loading="lazy"
                />
                <span className="series-badge badge-ongoing">Ongoing</span>
              </div>
              <div className="series-folder-info">
                <h3 className="section-subtitle">Barnyard Noir</h3>
                <p className="section-content">
                  Detective Clop investigates the mysterious disappearance of
                  the last carrot.
                </p>
                <div className="series-folder-meta">
                  <span className="section-content">12 Episodes</span>
                  <a href="#">
                    <div className="btn btn-sm btn-link">
                      <span>Open Folder</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div className="series-folder-card">
              <div className="series-folder-visual">
                <img
                  src="https://images.pexels.com/photos/14017540/pexels-photo-14017540.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Physics are Optional"
                  loading="lazy"
                />
                <span className="series-badge badge-complete">Complete</span>
              </div>
              <div className="series-folder-info">
                <h3 className="section-subtitle">Physics are Optional</h3>
                <p className="section-content">
                  A collection of comics where the laws of nature simply stopped
                  caring.
                </p>
                <div className="series-folder-meta">
                  <span className="section-content">30 Episodes</span>
                  <a href="#">
                    <div className="btn btn-sm btn-link">
                      <span>Open Folder</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div className="series-folder-card">
              <div className="series-folder-visual">
                <img
                  src="https://images.pexels.com/photos/1749900/pexels-photo-1749900.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Guest Gallops"
                  loading="lazy"
                />
                <span className="series-badge badge-ongoing">Ongoing</span>
              </div>
              <div className="series-folder-info">
                <h3 className="section-subtitle">Guest Gallops</h3>
                <p className="section-content">
                  Crossover episodes featuring other weird creatures from the
                  cartoon multiverse.
                </p>
                <div className="series-folder-meta">
                  <span className="section-content">8 Episodes</span>
                  <a href="#">
                    <div className="btn btn-sm btn-link">
                      <span>Open Folder</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="filter-station">
        <div className="filter-station-container">
          <div className="filter-station-tabs">
            <button data-target="tags" className="filter-tab active">
              Tags
            </button>
            <button data-target="characters" className="filter-tab">
              Characters
            </button>
            <button data-target="themes" className="filter-tab">
              Themes
            </button>
            <button data-target="time" className="filter-tab">
              Timeline
            </button>
          </div>
          <div className="filter-station-panes">
            <div id="pane-tags" className="filter-pane active">
              <div className="filter-chip-group">
                <button className="filter-chip">#Absurdist (120)</button>
                <button className="filter-chip">#Surreal (84)</button>
                <button className="filter-chip active">
                  #HorseProblems (210)
                </button>
                <button className="filter-chip">#GravityFails (45)</button>
                <button className="filter-chip">#CoffeeBreak (12)</button>
                <button className="filter-chip">#InternetCulture (156)</button>
                <button className="filter-chip">#Wormhole (5)</button>
              </div>
            </div>
            <div id="pane-characters" className="filter-pane">
              <div className="filter-chip-group">
                <button className="filter-chip">Mike (342)</button>
                <button className="filter-chip">Detective Clop (15)</button>
                <button className="filter-chip">The Invisible Pony (0?)</button>
                <button className="filter-chip">Barnaby the Bread (22)</button>
                <button className="filter-chip">Gravity Dave (8)</button>
              </div>
            </div>
            <div id="pane-themes" className="filter-pane">
              <div className="filter-chip-group">
                <button className="filter-chip">Existential Dread (55)</button>
                <button className="filter-chip">Bad Puns (402)</button>
                <button className="filter-chip">Slapstick (89)</button>
                <button className="filter-chip">Corporate Satire (31)</button>
              </div>
            </div>
            <div id="pane-time" className="filter-pane">
              <div className="filter-chip-group">
                <button className="filter-chip">The Golden Era (2024)</button>
                <button className="filter-chip">The Weird Era (2025)</button>
                <button className="filter-chip">
                  The Current Chaos (2026)
                </button>
              </div>
            </div>
          </div>
          <div className="active-filters-summary">
            <span className="section-content">
              <span>
                Active:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="archive-series-text20">#HorseProblems</span>
            </span>
            <span className="results-count">Showing 210 results</span>
            <button className="btn btn-sm btn-link">Clear All</button>
          </div>
        </div>
      </section>
      <section id="episodes" className="infinite-archive">
        <div className="infinite-archive-wrapper">
          <div className="archive-toolbar">
            <h2 className="section-title">The Master List</h2>
            <div className="view-toggle">
              <button title="Grid View" className="view-btn active">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <rect x="3" y="3" width="7" height="7"></rect>
                  <rect x="14" y="3" width="7" height="7"></rect>
                  <rect x="14" y="14" width="7" height="7"></rect>
                  <rect x="3" y="14" width="7" height="7"></rect>
                </svg>
              </button>
              <button title="List View" className="view-btn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <line x1="8" y1="6" x2="21" y2="6"></line>
                  <line x1="8" y1="12" x2="21" y2="12"></line>
                  <line x1="8" y1="18" x2="21" y2="18"></line>
                  <line x1="3" y1="6" x2="3.01" y2="6"></line>
                  <line x1="3" y1="12" x2="3.01" y2="12"></line>
                  <line x1="3" y1="18" x2="3.01" y2="18"></line>
                </svg>
              </button>
            </div>
          </div>
          <div className="archive-grid">
            <div className="archive-card">
              <div className="archive-card-thumb">
                <img
                  src="https://images.pexels.com/photos/137595/pexels-photo-137595.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Episode 142"
                  loading="lazy"
                />
                <span className="archive-card-type">Episode</span>
              </div>
              <div className="archive-card-body">
                <div className="archive-card-header">
                  <span className="series-label">Mike the Blue Horse</span>
                  <span className="date-label">2 hours ago</span>
                </div>
                <h3 className="section-subtitle">Gravity is a Suggestion</h3>
                <div className="archive-card-tags">
                  <span className="tag-mini">#Mike</span>
                  <span className="tag-mini">#Physics</span>
                </div>
              </div>
            </div>
            <div className="archive-card">
              <div className="archive-card-thumb">
                <img
                  src="https://images.pexels.com/photos/7313450/pexels-photo-7313450.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Meme Panel"
                  loading="lazy"
                />
                <span className="archive-card-type">Meme</span>
              </div>
              <div className="archive-card-body">
                <div className="archive-card-header">
                  <span className="series-label">Ketameme Classics</span>
                  <span className="date-label">Yesterday</span>
                </div>
                <h3 className="section-subtitle">
                  When the hay hits different
                </h3>
                <div className="archive-card-tags">
                  <span className="tag-mini">#Relatable</span>
                  <span className="tag-mini">#Hay</span>
                </div>
              </div>
            </div>
            <div className="archive-card">
              <div className="archive-card-thumb">
                <img
                  src="https://images.pexels.com/photos/14037324/pexels-photo-14037324.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Episode 141"
                  loading="lazy"
                />
                <span className="archive-card-type">Episode</span>
              </div>
              <div className="archive-card-body">
                <div className="archive-card-header">
                  <span className="series-label">Mike the Blue Horse</span>
                  <span className="date-label">3 days ago</span>
                </div>
                <h3 className="section-subtitle">The Great Carrot Heist</h3>
                <div className="archive-card-tags">
                  <span className="tag-mini">#Mike</span>
                  <span className="tag-mini">#Heist</span>
                </div>
              </div>
            </div>
            <div className="archive-card">
              <div className="archive-card-thumb">
                <img
                  src="https://images.pexels.com/photos/29702599/pexels-photo-29702599.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Episode 12"
                  loading="lazy"
                />
                <span className="archive-card-type">Episode</span>
              </div>
              <div className="archive-card-body">
                <div className="archive-card-header">
                  <span className="series-label">Barnyard Noir</span>
                  <span className="date-label">Last Week</span>
                </div>
                <h3 className="section-subtitle">
                  The Case of the Missing Trot
                </h3>
                <div className="archive-card-tags">
                  <span className="tag-mini">#Clop</span>
                  <span className="tag-mini">#Mystery</span>
                </div>
              </div>
            </div>
            <div className="archive-card">
              <div className="archive-card-thumb">
                <img
                  src="https://images.pexels.com/photos/3905773/pexels-photo-3905773.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Meme Panel"
                  loading="lazy"
                />
                <span className="archive-card-type">Meme</span>
              </div>
              <div className="archive-card-body">
                <div className="archive-card-header">
                  <span className="series-label">Ketameme Classics</span>
                  <span className="date-label">2 Weeks Ago</span>
                </div>
                <h3 className="section-subtitle">Monday Morning Muzzles</h3>
                <div className="archive-card-tags">
                  <span className="tag-mini">#Monday</span>
                  <span className="tag-mini">#Coffee</span>
                </div>
              </div>
            </div>
            <div className="archive-card">
              <div className="archive-card-thumb">
                <img
                  src="https://images.pexels.com/photos/6898855/pexels-photo-6898855.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Episode 45"
                  loading="lazy"
                />
                <span className="archive-card-type">Episode</span>
              </div>
              <div className="archive-card-body">
                <div className="archive-card-header">
                  <span className="series-label">Existential Stable</span>
                  <span className="date-label">1 Month Ago</span>
                </div>
                <h3 className="section-subtitle">The Wall Speaks Back</h3>
                <div className="archive-card-tags">
                  <span className="tag-mini">#Surreal</span>
                  <span className="tag-mini">#Deep</span>
                </div>
              </div>
            </div>
          </div>
          <div className="archive-loader">
            <div className="loader-spinner"></div>
            <p className="section-content">Summoning more chaos...</p>
          </div>
        </div>
      </section>
      <section className="character-showcase">
        <div className="character-showcase-wrapper">
          <div className="showcase-intro">
            <h2 className="section-title">The Usual Suspects</h2>
            <p className="section-content">
              Click a face to see their specific brand of nonsense.
            </p>
          </div>
          <div className="character-scroller">
            <div className="character-item">
              <div className="character-avatar">
                <img
                  src="https://images.pexels.com/photos/1319584/pexels-photo-1319584.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Mike"
                />
              </div>
              <span className="character-name">Mike</span>
            </div>
            <div className="character-item">
              <div className="character-avatar">
                <img
                  src="https://images.pexels.com/photos/137595/pexels-photo-137595.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Clop"
                />
              </div>
              <span className="character-name">Det. Clop</span>
            </div>
            <div className="character-item">
              <div className="character-avatar">
                <img
                  src="https://images.pexels.com/photos/7123065/pexels-photo-7123065.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Barnaby"
                />
              </div>
              <span className="character-name">Barnaby</span>
            </div>
            <div className="character-item">
              <div className="character-avatar">
                <img
                  src="https://images.pexels.com/photos/11798029/pexels-photo-11798029.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Dave"
                />
              </div>
              <span className="character-name">Gravity Dave</span>
            </div>
            <div className="character-item">
              <div className="character-avatar">
                <img
                  src="https://images.pexels.com/photos/14037324/pexels-photo-14037324.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="The Void"
                />
              </div>
              <span className="character-name">The Void</span>
            </div>
            <div className="character-item">
              <div className="character-avatar">
                <img
                  src="https://images.pexels.com/photos/218444/pexels-photo-218444.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Sticker"
                />
              </div>
              <span className="character-name">Sticker</span>
            </div>
            <div className="character-item">
              <div className="character-avatar">
                <img
                  src="https://images.pexels.com/photos/1749900/pexels-photo-1749900.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Stop Sign"
                />
              </div>
              <span className="character-name">Stop Sign</span>
            </div>
          </div>
        </div>
      </section>
      <section className="series-timeline">
        <div className="series-timeline-wrapper">
          <div className="timeline-header">
            <h2 className="section-title">Mike&apos;s Timeline of Regret</h2>
            <p className="section-content">
              From &quot;I think I&apos;m a horse&quot; to &quot;I definitely
              shouldn&apos;t have eaten that portal&quot;.
            </p>
          </div>
          <div className="timeline-container">
            <div className="timeline-track">
              <div className="timeline-event">
                <div className="event-marker">
                  <span>1</span>
                </div>
                <div className="event-card">
                  <span className="event-arc">Arc: The Beginning</span>
                  <h4 className="section-subtitle">Episode 1: Hello World</h4>
                  <p className="section-content">
                    Mike discovers grass. Grass is suspicious.
                  </p>
                  <a href="#">
                    <div className="btn btn-sm btn-link">
                      <span>Read Now</span>
                    </div>
                  </a>
                </div>
              </div>
              <div className="timeline-event">
                <div className="event-marker">
                  <span>15</span>
                </div>
                <div className="event-card">
                  <span className="event-arc">Arc: Physics 101</span>
                  <h4 className="section-subtitle">Episode 15: Up is Down</h4>
                  <p className="section-content">
                    Mike accidentally disables gravity for the stable.
                  </p>
                  <a href="#">
                    <div className="btn btn-sm btn-link">
                      <span>Read Now</span>
                    </div>
                  </a>
                </div>
              </div>
              <div className="timeline-event key-arc">
                <div className="event-marker">
                  <span>⭐</span>
                </div>
                <div className="event-card">
                  <span className="event-arc">KEY ARC: The Blue Shift</span>
                  <h4 className="section-subtitle">Episode 42: Color Theory</h4>
                  <p className="section-content">
                    The iconic moment Mike turns blue. Forever.
                  </p>
                  <a href="#">
                    <div className="btn btn-sm btn-link">
                      <span>Read Now</span>
                    </div>
                  </a>
                </div>
              </div>
              <div className="timeline-event">
                <div className="event-marker">
                  <span>60</span>
                </div>
                <div className="event-card">
                  <span className="event-arc">Arc: The Void</span>
                  <h4 className="section-subtitle">
                    Episode 60: Staring Contest
                  </h4>
                  <p className="section-content">
                    Mike stares at the abyss. The abyss blinks first.
                  </p>
                  <a href="#">
                    <div className="btn btn-sm btn-link">
                      <span>Read Now</span>
                    </div>
                  </a>
                </div>
              </div>
              <div className="timeline-event">
                <div className="event-marker">
                  <span>100</span>
                </div>
                <div className="event-card">
                  <span className="event-arc">Arc: Centenary</span>
                  <h4 className="section-subtitle">Episode 100: Party Time</h4>
                  <p className="section-content">
                    A celebration of 100 mistakes.
                  </p>
                  <a href="#">
                    <div className="btn btn-sm btn-link">
                      <span>Read Now</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="serendipity-cta">
        <div className="serendipity-cta-container">
          <div className="serendipity-card">
            <div className="serendipity-visual">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="64"
                viewBox="0 0 24 24"
                fill="none"
                stroke="var(--color-accent)"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20 21h-4v-4m0 4l5-5M6.5 9.504l-3.5-2L5 4M3 7.504l6.83-1.87M4 16l4-1l1 4m-1-4l-3.5 6M21 5l-.5 4l-4-.5m4 .5L16 3.5"></path>
              </svg>
            </div>
            <h2 className="section-title">Feeling Lucky, Pony?</h2>
            <p className="section-content">
              Let the algorithm of chaos decide your next 5 minutes. No logic
              guaranteed.
            </p>
            <div className="serendipity-actions">
              <button className="btn btn-accent btn-lg">
                Teleport to Random Meme
              </button>
              <button className="btn btn-primary btn-lg">
                Surprise Episode
              </button>
            </div>
            <p className="secondary-text section-content">
              Warning: May cause spontaneous neighing.
            </p>
          </div>
        </div>
      </section>
      <div className="archive-series-container2">
        <div className="archive-series-container3">
          <Script
            html={`<style>
        @keyframes fadeIn {from {opacity: 0;
transform: translateY(5px);}
to {opacity: 1;
transform: translateY(0);}}@keyframes spin {to {transform: rotate(360deg);}}@keyframes float {0%,100% {transform: translateY(0) rotate(0);}
50% {transform: translateY(-10px) rotate(5deg);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="archive-series-container4">
        <div className="archive-series-container5">
          <Script
            html={`<script defer data-name="archive-logic">
(function(){
  // Tab functionality
  const tabs = document.querySelectorAll('.filter-tab');
  const panes = document.querySelectorAll('.filter-pane');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const target = tab.getAttribute('data-target');
      
      // Update active tab
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      
      // Update active pane
      panes.forEach(pane => {
        pane.classList.remove('active');
        if (pane.id === \`pane-\${target}\`) {
          pane.classList.add('active');
        }
      });
    });
  });

  // Chip selection
  const chips = document.querySelectorAll('.filter-chip');
  chips.forEach(chip => {
    chip.addEventListener('click', () => {
      chip.classList.toggle('active');
    });
  });

  // View toggle simulation
  const viewBtns = document.querySelectorAll('.view-btn');
  const archiveGrid = document.querySelector('.archive-grid');

  viewBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      viewBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      
      // In a real app, this would toggle a class on archiveGrid
      // and change the layout from grid to list.
    });
  });

  // Infinite scroll simulation
  let loading = false;
  window.addEventListener('scroll', () => {
    if (loading) return;
    
    const archive = document.querySelector('.infinite-archive');
    if (window.innerHeight + window.scrollY >= archive.offsetHeight + archive.offsetTop - 200) {
      loading = true;
      // Simulate API call
      setTimeout(() => {
        loading = false;
      }, 2000);
    }
  });

  // Character filter simulation
  const characters = document.querySelectorAll('.character-item');
  characters.forEach(char => {
    char.addEventListener('click', () => {
      const name = char.querySelector('.character-name').textContent;
      // Scroll to archive and highlight
      document.getElementById('episodes').scrollIntoView({ behavior: 'smooth' });
    });
  });
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default ArchiveSeries
